import { find, get, some, isEqual } from 'lodash';

export const isSelectedOption = (array, value) =>
  !!array.find((selected) => selected.value === value);

export const enhanceOptionsWithIsSelected = (values, selectedValues) =>
  values.map((option) => ({
    ...option,
    isSelected: isSelectedOption(selectedValues, option.value),
  }));

export const getAvailableCriterionOptions = ({
  options = [],
  values = [],
  currentGroupRefId = null,
}) => {
  const groupedValues = [];
  values.forEach((selected) => {
    const selectedOptions =
      selected.refId !== currentGroupRefId ? get(selected, 'values', []) : [];

    groupedValues.push(...selectedOptions);
  });

  return options.filter(({ value }) => !some(groupedValues, ['value', value]));
};

export const getUngroupedValues = (values = []) =>
  values.filter(({ isGroup }) => !isGroup);

export const getCurrentGroupValues = (values = [], refId) =>
  get(find(values, ['refId', refId]), 'values', []);

export const getAllGroups = (values = []) =>
  values.filter(({ isGroup }) => isGroup);

export const getAllGroupValues = (values = []) =>
  values.reduce((accumulator, item) => {
    if (item.isGroup) {
      return [...accumulator, ...item.values];
    }

    return accumulator;
  }, []);

export function hasGroupsWithExactlySameValues(criterion) {
  if (!criterion.supportsBulkInput) {
    return false;
  }

  const groups = getAllGroups(criterion.values);
  if (groups.length < 2) {
    return false;
  }

  const groupValues = groups.map((group) =>
    group.values.map(({ value }) => value).sort(),
  );

  return groupValues.some((current, index) =>
    groupValues.slice(index + 1).some((other) => isEqual(current, other)),
  );
}
